import CarService from "../../services/CarService";

export default function CarCategoryView({
                                            categoryId
                                        }) {


    const category = CarService.carCategories.find((category) => category.id == categoryId);

    if (category != null) {
        return <img src={category.icon} className="w-[200px]"/>
    }
    return null;
}